
export const MICROSOFT_MAX_REMINDERS = 1;
export const GOOGLE_MAX_REMINDERS = 5;

export const SUPPORTED_PROVIDERS = {
  'google': GOOGLE_MAX_REMINDERS,
  'microsoft': MICROSOFT_MAX_REMINDERS
}